import { render } from "./topHeader.vue?vue&type=template&id=bf54fb60"
import script from "./topHeader.vue?vue&type=script&lang=js"
export * from "./topHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__